import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { pluck } from 'rxjs/operators';
import { ColorsService } from '../core/services/colors.service';
import { ProjectApiService } from '../core/services/project-api.service';
import { UserService } from '../core/services/user.service';
import { Load, LoadingSpaceType, Trucks } from '../core/types';

@Component({
    selector: 'gl-edit-menu',
    templateUrl: './edit-menu.component.html',
    styleUrls: ['./edit-menu.component.scss'],
    standalone: false
})
export class EditMenuComponent {
  public form: CustomForm;
  public colors = [];
  public loadingSpaces: LoadingSpaceType[];
  public currentColor: number;

  constructor(
    private userService: UserService,
    private projectApiService: ProjectApiService,
    private colorsService: ColorsService,
  ) {
    this.userService.user.pipe(pluck('trucks')).subscribe((trucks: Trucks) => {
      trucks.user.forEach((truck) => (truck.isUser = true));
      this.loadingSpaces = this.sortByVolume(trucks.standard.concat(trucks.user));
    });
    this.form = this.generateForm();
    this.colors = this.colorsService.generateColorsList();
  }

  public createProject() {
    if (this.form.valid) {
      const y = _.floor(this.form.value.loadingSpace.height / this.form.value.loadLength);
      const x = _.floor(this.form.value.loadingSpace.width / this.form.value.loadLength);
      const z = _.floor(this.form.value.loadingSpace.length / this.form.value.loadLength);
      const quantity = x * y * z;
      this.projectApiService.newProject().subscribe(() => {
        const loadingSpaceAdd = {
          currentWorkSpaceId: 1,
          newLoadingSpaces: {
            quantity: 1,
            loadingSpace: {
              ...this.form.value.loadingSpace,
            },
          },
        };
        this.projectApiService.addLoadingSpace(loadingSpaceAdd).subscribe(() => {
          const addLoad: Partial<Load> = {
            length: this.form.value.loadLength,
            width: this.form.value.loadLength,
            height: this.form.value.loadLength,
            stacking: true,
            name: 'load_without_name',
            weight: 0,
            allowToRotate: true,
            color: this.currentColor ? this.currentColor : this.colorsService.getColor(),
          };

          this.projectApiService
            .addGroup({
              currentWorkSpaceId: 1,
              newLoads: [
                {
                  quantity,
                  load: addLoad,
                },
              ],
            })
            .subscribe();
        });
      });
    }
  }

  public changeColor(i: number) {
    this.currentColor = this.colorsService.getColorFromList(i);
    this.colorsService.currentColor = this.colorsService.getColorFromList(i);
  }

  private sortByVolume(loadingSpaces: LoadingSpaceType[]) {
    return loadingSpaces.sort(
      (a, b) =>
        a.length * a.width * a.height +
        a.length1 * a.width1 * a.height1 -
        (b.length * b.width * b.height + b.length1 * b.width1 * b.height1),
    );
  }

  private generateForm() {
    return new UntypedFormGroup({
      loadLength: new UntypedFormControl(null, Validators.required),
      loadingSpace: new UntypedFormControl(null, Validators.required),
    });
  }
}

interface CustomForm extends UntypedFormGroup {
  value: {
    loadLength: number;
    loadingSpace: LoadingSpaceType;
  };
}
